<template>
  <div class="box">
    <RoundIcon>
      <slot name="icon"/>
    </RoundIcon>

    <span class="box__text">
      <slot/>
    </span>
  </div>
</template>

<script>
import RoundIcon from '@/components/icon/RoundIcon'

export default {
  components: {
    RoundIcon,
  }
}
</script>

<style scoped lang="scss">
  .box {
    display: flex;
    align-items: center;
    gap: 8px;

    &__text {
      font-size: 0.89rem;
    }
  }
</style>